import ActivitySettingsTab from './activity-settings';

export default ActivitySettingsTab;
